module.exports = __webpack_public_path__ + "assets/img/cut3.f969d278.png";